export default __webpack_public_path__ + "static/media/nie_logo.db34ec62.png";